export const EXTERNAL_LINKS_REL = 'nofollow noopener noreferrer'
